import Page from "./Page";
import Menu from "./Menu";

export default class EpisodeList extends Page {
	constructor () {

		super();
		new Menu('submenu');
	}
}